import { FormEvent } from 'react';

export function validateFormSubmit(e: FormEvent): boolean {
  const form = e.currentTarget as HTMLFormElement;
  form.classList.add('form-submitted');
  if (!form.checkValidity()) {
    e.preventDefault();
    const firstInvalid = form.querySelector<HTMLElement>(':invalid');
    firstInvalid?.focus();
    return false;
  }
  return true;
}

export function clearFormFieldErrors(form: HTMLFormElement): void {
  form.querySelectorAll('.form-group--error').forEach(el => {
    el.classList.remove('form-group--error');
  });
  form.querySelectorAll('.field-error').forEach(el => {
    el.remove();
  });
}
